export default {
  read: {
    title: "Productos",
    subtitle: "Todos tus productos para mostarlos a tus potenciales clientes.",
    see: "Ver tienda",
    steps: {
      products: "Productos",
      orders: "Pedidos"
    },
    status: {
      enabled: "Activado",
      disabled: "Desactivado"
    },
    modalOrder: {
      title: "Pedido",
      delivery: "Empresa repartidora",
      trackingCode: "Código de seguimiento",
      status: {
        label: "Estado",
        options: {
          pending: "Pendiente de aceptar",
          accepted: "Aceptado",
          sent: "Enviado",
          delivered: "Entregado"
        }
      },
      billAddress: "Dirección de facturación",
      deliveryAddress: "Dirección de entrega",
      table: {
        name: "Nombre",
        products: "Productos",
        price: "Precio",
        total: "Total"
      }
    },
    modalDelete: {
      content: '¿Estás seguro de que quieres eliminar el producto "{title}"?'
    },
    currency: {
      euro: "€"
    },
    percent: "%",
    total: "Total",
    productsTable: {
      name: "Nombre",
      discount: "Descuento",
      products: "Productos",
      price: "Precio",
      status: {
        label: "Estado",
        options: {
          enabled: "Activado",
          disabled: "Desactivado"
        }
      },
      actions: "Acciones"
    },
    ordersTable: {
      name: "Nombre",
      trackingCode: "Código de seguimiento",
      products: "Productos",
      total: "Total",
      status: "Estado",
      actions: "Acciones"
    },
    newProduct: "Nuevo producto"
  },
  create: {
    title: "Nuevo producto",
    subtitle: "Configura aquí tu producto",
    form: {
      highlight: {
        label: "Destacar producto",
        under: "Producto desctacado"
      },
      mainImg: "Imagen principal",
      addImage: "Añadir imagen",
      images: "Imágenes Adicionales",
      productName: "Nombre del producto",
      description: "Descripción",
      price: "Precio (€)",
      discount: "Descuento (%)",
      stock: "Stock",
      deliveryTime: "Tiempo de entrega"
    },
    notifications: {
      productSaved: "Producto guardado con éxito",
      productUpdated: "Producto actualizado con éxito",
      productRemoved: "Producto eliminado con éxito"
    }
  }
};
